import {
  CreditActionTypes,
  IStartCheckoutSessionPayload,
} from './types'

export const startCheckoutSession = (payload: IStartCheckoutSessionPayload) => ({
  type: CreditActionTypes.START_CHECKOUT_SESSION,
  payload
})

export const startCheckoutSessionFailure = () => ({
  type: CreditActionTypes.START_CHECKOUT_SESSION_FAILURE,
})
